/**
 * theme-custom.js
 *
 * Sisältää custom JavaScript -toiminnallisuudet.
 * HUOM: Osa koodista on väliaikaisia korjauksia muiden JS-virheiden vuoksi.
 * On erittäin suositeltavaa tunnistaa ja korjata alkuperäisten virheiden juurisyy
 * selaimen konsolista vakaamman ratkaisun saamiseksi.
 */
 


console.log('theme-custom.js loaded');  







// ==========================================================================
// Custom ALV Calculation Logic (Possibly Depends on other scripts setting prices)
// Kept in setTimeout based on original code. Timing can be uncertain.
// Consider re-evaluating its placement and dependencies if issues arise.
// ==========================================================================


// Apufunktio hinnan parsintaan stringistä numeroksi (yritetään käsitellä € ja ,/.)
function parsePriceString(priceString) {
  if (!priceString) return NaN;

  // Poista valuuttasymboli (€) ja ylimääräiset välilyönnit
  let cleanString = priceString.replace(/€/g, '').trim();

  // Korvaa desimaalipilkku pisteeksi parsintaa varten
  cleanString = cleanString.replace(',', '.');

  // Poista tuhaterottimet (jos käytössä, esim. 1.234,50 -> 1234.50). 
  // Tämä rivi olettaa, että piste EI ole desimaalierotin.
  // Jos valuuttamuotoilu on toinen, tämä kohta pitää muokata.
  cleanString = cleanString.replace(/\./g, '');

  // Kokeillaan uudestaan desimaalipilkulla pisteeksi (jos yllä oleva poisti vahingossa)
  cleanString = cleanString.replace(',', '.');

  // Yritä parsia numero
  return parseFloat(cleanString);
}





// Apufunktio hinnan muotoiluun numerosta stringiksi (yritetään takaisin suomalaiseen muotoon)
function formatPriceString(priceNumber) {
  if (isNaN(priceNumber)) return '';

  // Muotoile numero 2 desimaalilla
  const formatted = priceNumber.toFixed(2);

  // Korvaa piste pilkuksi ja lisää valuuttasymboli
  return formatted.replace('.', ',') + ' €';
}





// ==========================================================================
// Custom ALV Calculation Logic (korjattu versio)
// ==========================================================================
function updatePricesWithVAT() {
  const vatRate = 1.255; // Kerroin 25.5% ALV:lle

  // 1) Varianttien hinnat
  document.querySelectorAll('[data-product-variant-id] .price.money').forEach(priceEl => {
    const priceSentit = parsePriceString(priceEl.textContent);
    if (isNaN(priceSentit)) return;

    const priceEur = priceSentit / 100; // Sentit → eurot
    const vatPrice = priceEur * vatRate; // Lisää ALV
    const formattedVatPrice = formatPriceString(vatPrice);

    const priceWithTaxEl = document.getElementById('vat24-price');
    if (priceWithTaxEl) priceWithTaxEl.textContent = formattedVatPrice;
  });

  // 2) Tuotteen perushinnat (ilman variant-id:tä)
  document.querySelectorAll('[data-product-id]:not([data-product-variant-id]) .price.money').forEach(priceEl => {
    const priceSentit = parsePriceString(priceEl.textContent);
    if (isNaN(priceSentit)) return;

    const priceEur = priceSentit / 100;
    const vatPrice = priceEur * vatRate;
    const formattedVatPrice = formatPriceString(vatPrice);

    const productId = priceEl.closest('[data-product-id]').getAttribute('data-product-id');
    const priceWithTaxEl = document.getElementById('vat-' + productId);

    if (priceWithTaxEl) priceWithTaxEl.textContent = formattedVatPrice;
  });

  // 3) Kaikki muut hinnat, joissa on .price-luokka
  document.querySelectorAll('[data-product-id] .price').forEach(priceEl => {
    const priceSentit = parsePriceString(priceEl.textContent);
    if (isNaN(priceSentit)) return;

    const priceEur = priceSentit / 100;
    const vatPrice = priceEur * vatRate;
    const formattedVatPrice = formatPriceString(vatPrice);

    const productId = priceEl.closest('[data-product-id]').getAttribute('data-product-id');
    const priceWithTaxEl = document.getElementById('vat-' + productId);

    if (priceWithTaxEl) priceWithTaxEl.textContent = formattedVatPrice;
  });
}

// Aja korjattu funktio viiveellä, kun sivu on latennut
setTimeout(updatePricesWithVAT, 300);


 




function initFormTracking() {
  const forms = document.querySelectorAll(
    'form.contact-form, form.company-form, form.info-form'
  );

  if (!forms.length) return;

  forms.forEach(function(form) {
    form.addEventListener('submit', function() {
      window.dataLayer = window.dataLayer || [];

      const classes = form.className || '';
      let formType = null;

      if (classes.includes('contact-form')) formType = 'contact-form';
      else if (classes.includes('company-form')) formType = 'company-form';
      else if (classes.includes('info-form')) formType = 'info-form';

      window.dataLayer.push({
        event: 'form_submit',
        form_type: formType,
        form_id: form.id || null,
        form_classes: classes,
        page_path: window.location.pathname
      });
    });
  });
}

 
 










 







// ==========================================================================
// Main DOMContentLoaded Listener
// Contains SKU/Saldo/Swatch logic (Product Page) and Cart Quantity Fix (Cart Page)
// ==========================================================================
document.addEventListener('DOMContentLoaded', () => {  


 
  //console.log('DOMContentLoaded fired in theme-custom.js');

  // ========================================================================
  // SKU, Saldo, and Swatch Logic (Product Page)
  // Handles updates on product pages when variants change.
  // ========================================================================

  // This logic runs only if the .infiniteoptions-container element is NOT present.
  if (!document.querySelector('.infiniteoptions-container')) {
    // Read product variants from the script tag
    const dataEl = document.querySelector('script[data-product-json]');
    const variants = dataEl
      ? JSON.parse(dataEl.textContent).product.variants
      : [];

    // Update SKU element on the product page
    function updateSku(variant) {
      const skuEl = document.querySelector('.product-meta__sku-number');
      if (skuEl && variant) skuEl.textContent = variant.sku || '';
    }

    function updateOptionLabelText(value) {
      const optionValueEl = document.querySelector('.product-form__selected-value');

      if (optionValueEl) {
        optionValueEl.textContent = value || '';
      } else {
        console.warn('updateOptionLabelText: option value element not found');
      }
    }
 




    function updateInventoryText(variant) {
      const inventoryEls = document.querySelectorAll('.product-form__inventory');

      if (!inventoryEls.length || !variant) return;

      inventoryEls.forEach((inventoryEl, index) => {
        const rawQty = typeof window.varQtyTable !== 'undefined'
          ? window.varQtyTable[variant.id]
          : null;

        const qty = rawQty !== null && rawQty !== undefined && rawQty !== ''
          ? parseInt(rawQty, 10)
          : null;

        inventoryEl.classList.remove('inventory--low', 'inventory--high', 'inventory--out');

        if (!isNaN(qty) && qty !== null) {
          if (qty > 0) {
            inventoryEl.textContent = `${qty} kpl varastossa`;
            inventoryEl.classList.add('inventory--high');
          } else {
            inventoryEl.textContent = 'Tilattavissa';
            inventoryEl.classList.add('inventory--low');
          }
        } else {
          inventoryEl.textContent = variant.available ? 'Tilattavissa' : 'Loppu varastosta';
          inventoryEl.classList.add(variant.available ? 'inventory--high' : 'inventory--out');
        }

        /*
        console.log('AFTER WRITE immediately:', index, inventoryEl.textContent);

        setTimeout(() => {
          console.log('AFTER 100ms:', index, inventoryEl.textContent);
        }, 100); 

        setTimeout(() => {
          console.log('AFTER 300ms:', index, inventoryEl.textContent);
        }, 300);

        */
       
      });
    }








    // Initial update on page load
    const initialVariantSelect = document.querySelector('select[name="id"]');

    if (initialVariantSelect && initialVariantSelect.value) {
      const initialVariant = variants.find(
        variant => variant.id.toString() === initialVariantSelect.value
      );

      if (initialVariant) {
        updateSku(initialVariant);
        
        setTimeout(() => {
           //updateInventoryText(initialVariant); 
        }, 5);
      }
    }

    // Listen for Dawn's variantChange event on product sections (if theme dispatches it)
    document.querySelectorAll('[data-section-type="product"]').forEach(section => {
      section.addEventListener('variantChange', e => {
        updateSku(e.detail.variant);
        
        setTimeout(() => {
         //updateInventoryText(e.detail.variant);
        }, 5); 

      });
    });

    document.querySelectorAll('.block-swatch__radio').forEach(radio => { 
      radio.addEventListener('change', () => {
        const origVal = radio.getAttribute('value');
        const pos = radio.dataset.optionPosition;
        const key = 'option' + pos;

        const v = variants.find(variant => variant[key] === origVal);

        if (!v) {
          console.warn('Custom JS: Swatch value not found in variants:', origVal, 'at position', key);
          return;
        }

        const select = document.querySelector('select[name="id"]');

        if (select) {
          select.value = v.id;
          select.dispatchEvent(new Event('change', { bubbles: true }));

          updateSku(v);
          updateOptionLabelText(origVal);
          
          setTimeout(() => {
            updateInventoryText(v);
          }, 5); 
          
        }
      });
    });
  
  

 








 

    document.querySelectorAll('.quantity-selector--product').forEach(selector => {
      const decreaseButton = selector.querySelector('[data-action="decrease-picker-quantity"]');
      const increaseButton = selector.querySelector('[data-action="increase-picker-quantity"]');
      const quantityInput = selector.querySelector('input[name="quantity"]');

      if (!decreaseButton || !increaseButton || !quantityInput) return;

      decreaseButton.addEventListener('click', event => {
        event.preventDefault();
        event.stopImmediatePropagation(); // 🔥 tärkeä

        let currentValue = parseInt(quantityInput.value, 10);
        if (isNaN(currentValue) || currentValue < 1) currentValue = 1;

        const minValue = parseInt(quantityInput.getAttribute('min'), 10) || 1;
        const newValue = Math.max(minValue, currentValue - 1);

        quantityInput.value = newValue;
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      });

      increaseButton.addEventListener('click', event => {
        event.preventDefault();
        event.stopImmediatePropagation(); // 🔥 tärkeä

        let currentValue = parseInt(quantityInput.value, 10);
        if (isNaN(currentValue) || currentValue < 1) currentValue = 1;

        const maxAttr = quantityInput.getAttribute('max');
        const maxValue = maxAttr ? parseInt(maxAttr, 10) : null;

        let newValue = currentValue + 1;
        if (!isNaN(maxValue) && maxValue !== null) {
          newValue = Math.min(maxValue, newValue);
        }

        quantityInput.value = newValue;
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });

 



    /* TÄÄ OLI EDELLINEN KOODI, KORVATTU YLLÄ OLEVALLA KOODILLA 19.8.2025
    // Swatch radio button click listener to sync with the main select element
    document.querySelectorAll('.block-swatch__radio').forEach(radio => {
      radio.addEventListener('change', () => {
        const origVal = radio.getAttribute('value');
        const v = variants.find(v => v.option1 === origVal); // Find variant by option1 (assuming swatch represents option1)

        if (!v) return console.warn('Custom JS: Swatch value not found in variants:', origVal);

        // Set the main select element's value
        const select = document.querySelector('select[name="id"]');
        if (select) {
          select.value = v.id;

          // Dispatch 'change' event on the select to trigger theme's native logic
          select.dispatchEvent(new Event('change', { bubbles: true }));

          // Update SKU directly as well for immediate feedback
          updateSku(v);

          // Optional: Trigger ALV update here as well after a slight delay
          // setTimeout(updatePricesWithVAT, 50); // Adjust delay if needed
        }
      });
    });
    */



/*


    // --- Saldo Update Logic ---
    // This part handles the 'jalleenmyyjan-varastossa' and 'jalleenmyyjan-sku' updates
    // Requires globalVarTable and varQtyTable set in theme.liquid
    const saldoContainer = document.getElementById("jalleenmyyjan-varastossa");
    const skuContainer = document.getElementById("jalleenmyyjan-sku");
    const skuNumberElSaldo = document.querySelector('.product-meta__sku-number'); // Use the same SKU element or find the one relevant for Saldo

    if (
      saldoContainer &&
      skuContainer &&
      skuNumberElSaldo &&
      window.globalVarTable &&
      window.varQtyTable
    ) {
      // Check if elements and global tables exist

      // Function to update SKU and Saldo based on variant data
      function updateSkuAndSaldo(variant) {
        if (!variant) {
          // Handle case where no variant is selected or found
          saldoContainer.disabled = true;
          skuContainer.disabled = true;
          saldoContainer.value = "";
          skuContainer.value = "";
          //skuNumberElSaldo.textContent = ''; // Optionally clear main SKU display as well
          return;
        }

        // Update SKU element related to Saldo (if different from main SKU, otherwise remove this line)
        // skuNumberElSaldo.textContent = variant.sku || ''; // This might be redundant if updateSku already does this

        // Get inventory data, default to 0 if not a number
        let saldoTrue = typeof window.varQtyTable[variant.id] === 'number'
          ? window.varQtyTable[variant.id]
          : 0;

        let saldoFri = typeof window.globalVarTable[variant.id] === 'number'
          ? window.globalVarTable[variant.id]
          : 0;

        if (saldoTrue <= 5 && saldoFri > 0) {
          saldoContainer.disabled = false;
          skuContainer.disabled = false;
          saldoContainer.value = "Tarkista saldo" + "(" + saldoFri + ")"; // Display text + saldo
          skuContainer.value = variant.sku || ''; // Set SKU value
        } else {
          saldoContainer.disabled = true;
          skuContainer.disabled = true;
          saldoContainer.value = ""; // Clear value
          skuContainer.value = ""; // Clear value
        }
      }

      // Listen for the standard 'variant:changed' event (more general)
      document.addEventListener('variant:changed', function(event) {
        const variant = event.detail.variant;
        updateSkuAndSaldo(variant);
        updateInventoryText(variant);

        // If ALV depends on variant, uncomment the ALV update call here too:
        // setTimeout(updatePricesWithVAT, 50); // Update ALV after variant change and slight delay
      });

      // Initial state setup on page load (if a variant is already selected)
      const initialVariantSelect = document.querySelector('select[name="id"]');

      if (initialVariantSelect && initialVariantSelect.value && dataEl) {
        const productData = JSON.parse(dataEl.textContent).product;
        const initialVariant = productData.variants.find(
          v => v.id.toString() === initialVariantSelect.value
        );

        if (initialVariant) {
          updateSkuAndSaldo(initialVariant);
          updateInventoryText(initialVariant); 
        }
      }
    } else {
      // console.warn("Custom JS: SKU/Saldo elements or global tables not found on product page. Saldo logic skipped.");
    }


*/ 










    // --- End of Saldo Update Logic ---
  } // End if !infiniteoptions-container

  // ========================================================================
  // TEMPORARY FIX: Cart Quantity Buttons (Cart Page)
  // THIS IS A WORKAROUND DUE TO BROKEN THEME JS FOR CART UPDATES.
  // Forces a page reload after successful update to ensure UI consistency.
  // REMOVE THIS SECTION ONCE THE UNDERLYING JS ERRORS ARE FIXED.
  // ========================================================================

  // Check if currently on the cart page based on window.theme or body class
  if (
    (window.theme && window.theme.pageType === 'cart') ||
    document.body.classList.contains('template-cart')
  ) {
    console.log('Custom JS (Temporary Fix): Activating cart quantity buttons.');

    const quantitySelectors = document.querySelectorAll('.quantity-selector');

    quantitySelectors.forEach(selector => {
      const decreaseButton = selector.querySelector('.quantity-selector__button[data-action="decrease-quantity"]');
      const increaseButton = selector.querySelector('.quantity-selector__button[data-action="increase-quantity"]');
      const quantityInput = selector.querySelector('.quantity-selector__value');

      // Assuming the remove link is the next sibling element
      const removeLink = selector.nextElementSibling;

      if (decreaseButton && increaseButton && quantityInput) {
        // Add event listeners for clicks on +/- buttons
        decreaseButton.addEventListener('click', handleCustomQuantityChange);
        increaseButton.addEventListener('click', handleCustomQuantityChange);

        // Add event listener for manual changes in the input field
        quantityInput.addEventListener('change', handleManualQuantityChange);

        // Add listener for the 'Remove' link if it exists and matches the structure
        if (
          removeLink &&
          removeLink.classList.contains('line-item__quantity-remove')
        ) {
          // The remove link in main-cart.liquid has data-action="decrease-quantity" and data-quantity="0"
          // So the same handler can be used.
          removeLink.addEventListener('click', handleCustomQuantityChange);
        }
      } else {
        console.warn("Custom JS (Temporary Fix): Could not find all required elements for a quantity selector in the DOM.");
      }
    });

    // Event handler for button clicks (+, -, Remove)
    function handleCustomQuantityChange(event) {
      event.preventDefault(); // Prevent default behavior (e.g., navigating link)
      event.stopPropagation(); // Prevent event from bubbling up further, just in case

      const button = event.target.closest('button') || event.target.closest('a'); // Get the button or link element

      if (!button) {
        console.warn('Custom JS (Temporary Fix): Click event triggered but target button/link not found.');
        return;
      }

      const lineItemIndex = button.getAttribute('data-line'); // Get the line index (1-based)

      if (!lineItemIndex) {
        console.error('Custom JS (Temporary Fix): Line index (data-line) not found on the button/link.');
        return;
      }

      let newQuantity;

      // Check if the quantity is explicitly set by a data-quantity attribute (used by Remove link)
      if (button.hasAttribute('data-quantity')) {
        newQuantity = parseInt(button.getAttribute('data-quantity'), 10);
      } else {
        // For +/- buttons, find the input field and calculate the new quantity
        const quantityInput = button.closest('.quantity-selector').querySelector('.quantity-selector__value');

        if (!quantityInput) {
          console.error('Custom JS (Temporary Fix): Quantity input not found relative to the button.');
          return;
        }

        let currentQuantity = parseInt(quantityInput.value, 10);

        if (isNaN(currentQuantity)) {
          console.error('Custom JS (Temporary Fix): Could not parse current quantity from input.');
          return;
        }

        const action = button.getAttribute('data-action');

        if (action === 'increase-quantity') {
          newQuantity = currentQuantity + 1;
        } else if (action === 'decrease-quantity') {
          newQuantity = currentQuantity - 1;
          if (newQuantity < 0) newQuantity = 0; // Quantity cannot be negative
        } else {
          console.warn('Custom JS (Temporary Fix): Unrecognized data-action:', action);
          return; // Exit if action is not increase/decrease
        }

        // Prevent decreasing below 0 or if the button is disabled
        if (button.disabled || (currentQuantity === 0 && action === 'decrease-quantity')) {
          console.log('Custom JS (Temporary Fix): Action prevented (button disabled or decreasing from 0).');
          return; // Do nothing
        }
      }

      // Call the function to update the cart via Shopify API
      updateCartQuantity(lineItemIndex, newQuantity);
    }

    // Event handler for manual input field changes
    function handleManualQuantityChange(event) {
      const input = event.target;
      const lineItemIndex = input.getAttribute('data-line');

      if (!lineItemIndex) {
        console.error('Custom JS (Temporary Fix): Line index (data-line) not found on the input field.');
        return;
      }

      let newQuantity = parseInt(input.value, 10);

      // Validate the input: must be a number and at least 0
      if (isNaN(newQuantity) || newQuantity < 0) {
        console.warn('Custom JS (Temporary Fix): Invalid quantity entered:', input.value);
        alert('Syötä kelvollinen määrä (vähintään 0).');

        // Reload page to revert the invalid input from the UI and show correct state
        window.location.reload();
        return;
      }

      // Update the cart via Shopify API
      updateCartQuantity(lineItemIndex, newQuantity);
    }

    // Function to perform the API call to update cart quantity and force page reload on success/error
    function updateCartQuantity(lineIndex, quantity) {
      // Use window.routes.cartChangeUrl provided by theme.liquid 
      if (!window.routes || !window.routes.cartChangeUrl) {
        console.error('Custom JS (Temporary Fix): Shopify routes object or cartChangeUrl not found in window.routes.');
        alert('Jokin kriittinen virhe: Ostoskorin päivitys ei mahdollinen. Routes object puuttuu.');
        return;
      }

      // Construct the change URL. lineIndex from main-cart.liquid is 1-based.
      //const changeUrl = ${window.routes.cartChangeUrl}?line=${lineIndex}&quantity=${quantity};
      const changeUrl = `${window.routes.cartChangeUrl}?line=${lineIndex}&quantity=${quantity}`;


      console.log(
        `Custom JS (Temporary Fix): Sending update request for line item ${lineIndex} to quantity ${quantity}. URL: ${changeUrl}`
      );

      // Use Fetch API to make the request
      fetch(changeUrl, {
        method: 'POST', // POST is the recommended method for changes
        headers: {
          'Content-Type': 'application/json', // Indicate that we accept JSON response
          'Accept': 'application/json' // Other headers might be needed depending on theme/apps, but usually not for basic cart change
        }
        // No body needed as parameters are in the URL for this endpoint
      })
        .then(response => {
          if (!response.ok) {
            console.error('Custom JS (Temporary Fix): Cart update API error:', response.status, response.statusText);

            return response.json()
              .then(data => {
                const errorMessage = data.message || data.description || `${response.status} ${response.statusText}`;
                alert(`Määrän päivittämisessä tapahtui virhe: ${errorMessage}. Yritä ladata sivu uudelleen.`);
                window.location.reload();
                throw new Error('API update failed');
              })
              .catch(() => {
                alert(`Määrän päivittämisessä tapahtui virhe: ${response.status} ${response.statusText}. Yritä ladata sivu uudelleen.`);
                window.location.reload();
                throw new Error('API update failed');
              });
          }

          // On success, force a page reload to ensure the entire cart UI (numbers, sums) updates correctly.
          // This is a workaround because the theme's native JS for updating the UI after a cart change appears broken.
          console.log('Custom JS (Temporary Fix): Cart update successful. Forcing page reload to update UI.');
          window.location.reload();

          // Do NOT dispatch cart:refresh if forcing reload, it's redundant and potentially confusing
          // document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
        })
        .catch(error => {
          // This catch handles network errors or errors thrown in the .then() block
          console.error('Custom JS (Temporary Fix): Fetch API error during cart update:', error);

          // An alert was likely already shown in the .then() block for response.ok == false
          // Show generic network error if it wasn't an API error response
          if (!error.message.includes('API update failed')) {
            alert('Määrän päivittämisessä tapahtui odottamaton verkkovirhe. Tarkista internet-yhteytesi tai yritä uudelleen.');

            // Optional: Force reload even on network error
            // window.location.reload();
          }
        });
    }
  } // End if on cart page

  // ========================================================================
  // Other potential custom hooks (e.g., product:added, cart:refresh listeners)
  // Add any other custom listeners or DOMContentLoaded code here if needed.
  // ========================================================================

  // Example product:added listener:
  // document.addEventListener('product:added', function(event) {
  //   console.log('Product added to cart:', event.detail.variant, 'Quantity:', event.detail.quantity);
  //   // You could add custom logic here, e.g., showing a custom mini-cart confirmation
  // });



  // ========================================================================
  // Form tracking
  // Tracks selected form submissions to dataLayer / GTM
  // ======================================================================== 
  initFormTracking();


}); // End of Main DOMContentLoaded listener. 